import { DownloadReportRevamp } from "@adapters/presenters/Reports/CoreReportsRevamp/DownloadReportRevamp";
export default (useCases, actions) => ({
    downloadReport: new DownloadReportRevamp(useCases.downloadAndSendReportUsecases, actions.downloadReportActions),
});
